module.exports = __webpack_public_path__ + "static/media/26UNRWA17.62599e91.jpg";